export const t = {
  // Form titles
  innameFormTitle: 'Inname formulier',
  ophaalFormTitle: 'Ophaal formulier',
  afleverFormTitle: 'Aflever formulier',
  omruilFormTitle: 'Omruil formulier',
  confirmationTitle: 'Formulier verzonden!',
  confirmationMessage: 'Het formulier is succesvol verzonden.',
  backToHome: 'Terug naar Home',
  instructions: 'Instructies',
  understood: 'Begrepen',
  
  // Actions
  sending: 'Bezig met verzenden...',
  generatingReport: 'PDF rapport genereren...',
  submit: 'Verzenden',
  shareForm: 'Deel formulier',
  shareableLink: 'Deelbare link',
  linkCopied: 'De link is gekopieerd naar je klembord. Deel deze link om het formulier met ingevulde gegevens te delen.',
  clear: 'Wissen',
  drawHere: 'Teken hier',
  goBack: 'Ga terug',
  clickToAddPhotos: "Klik om foto's toe te voegen",
  clickToTakePhoto: "Klik om een foto te maken",
  clearForm: 'Formulier wissen',
  clearFormConfirmation: 'Weet je zeker dat je het formulier wilt wissen?',

  // Input Modes
  inputModes: 'Afbeelding modus',
  cameraMode: 'Camera modus',
  cameraModeDescription: 'Gebruik de camera van je apparaat om direct nieuwe foto\'s te maken. Dit is handig wanneer je ter plekke nieuwe foto\'s wilt maken.',
  galleryMode: 'Galerij modus',
  galleryModeDescription: 'Selecteer bestaande foto\'s uit de galerij van je apparaat. Dit is handig wanneer je de foto\'s al hebt gemaakt.',

  // Homepage
  homepageTitle: 'Voertuig formulieren',
  homepageSubtitle: 'Selecteer een formulier om te beginnen',
  ophaalFormDescription: 'Voor het ophalen van een voertuig',
  afleverFormDescription: 'Voor het afleveren van een voertuig',
  omruilFormDescription: 'Voor het omruilen van een voertuig',
  innameFormDescription: 'Voor het innemen van een voertuig',

  // Debug translations
  debugFillForm: 'Debug: Vul formulier in',

  errors: {
    generic: 'Er is een fout opgetreden bij het verzenden van het formulier. Probeer het opnieuw.',
    rateLimit: 'Te veel verzoeken. Probeer het over {seconds} seconden opnieuw.',
    timeout: 'Het duurde te lang om je formulier te versturen. Controleer je internetverbinding en probeer het opnieuw.',
    network: 'Er is een netwerkfout opgetreden. Controleer je internetverbinding en probeer het opnieuw.',
    offline: 'Je bent offline. Controleer je internetverbinding en probeer het opnieuw.',
    server: 'Er is een serverfout opgetreden. Probeer het later opnieuw of neem contact op met de beheerder.',
    client: 'Er is een fout opgetreden met je verzoek. Controleer de ingevoerde gegevens en probeer het opnieuw.',
    retry: 'Opnieuw proberen',
    retryHint: 'Klik op "Opnieuw proberen" om het formulier opnieuw te verzenden.'
  },

  // Leave confirmation
  leaveConfirmation: {
    title: 'Pagina verlaten?',
    message: 'Je hebt niet-opgeslagen wijzigingen. Weet je zeker dat je de pagina wilt verlaten?',
    stay: 'Blijf op pagina',
    leave: 'Verlaat pagina'
  },

  // Install prompt
  installPrompt: {
    title: 'App installeren',
    message:
      'Voor de beste werking en om je gegevens goed op te slaan is het belangrijk dat je deze applicatie installeert. Voeg de app toe aan je startscherm voor snelle en eenvoudige toegang onderweg.',
    notNow: 'Niet nu',
    install: 'Installeren',
    iosTitle: 'Installeer deze app',
    iosMessage: 'Installeer deze app op je startscherm, om te verzekeren dat er geen ingevoerde data verloren gaat.',
    iosInstructions: {
      step1: 'Tik op het deel-icoon',
      step2: 'Scroll naar beneden en tik op "Voeg toe aan beginscherm"',
      step3: 'Tik op "Voeg toe" om te bevestigen',
    },
    iosShareIcon: '(het vierkant met een pijl omhoog)',
    dismiss: 'Sluiten',
  },
}; 